import { Match, MatchParticipant } from '../types';

export function normMatchStatus(status?: string): string {
  return (status || '').toLowerCase().replace(/-/g, '_');
}

export function matchStatusEquals(status: string | undefined, expected: string): boolean {
  return normMatchStatus(status) === normMatchStatus(expected);
}

export function getMatchParticipants(match: {
  participants?: MatchParticipant[];
  participants_data?: MatchParticipant[];
}): MatchParticipant[] {
  return match.participants ?? match.participants_data ?? [];
}

export function participantDisplayName(p: MatchParticipant): string {
  return (
    p.user_name ||
    p.guest_player_name ||
    (p.user_id != null ? `User #${p.user_id}` : 'Guest')
  );
}

export function formatMatchDateTime(date?: string, time?: string): string {
  if (!date) return 'TBD';
  const d = new Date(date);
  const dateStr = Number.isNaN(d.getTime())
    ? date.split('T')[0]
    : d.toLocaleDateString(undefined, {
        weekday: 'short',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
  const t =
    time?.slice(0, 5) ||
    (Number.isNaN(d.getTime())
      ? ''
      : d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' }));
  return t ? `${dateStr} · ${t}` : dateStr;
}

/** Map UI filter values to backend MatchStatus enum names. */
export function statusFilterToApi(status: string): string | undefined {
  if (status === 'all') return undefined;
  const map: Record<string, string> = {
    open: 'OPEN',
    waiting_admin_confirmation: 'WAITING_ADMIN_CONFIRMATION',
    confirmed: 'CONFIRMED',
    completed: 'COMPLETED',
    rejected: 'REJECTED',
  };
  const key = normMatchStatus(status);
  return map[key] || status.toUpperCase();
}

export function formatStatusLabel(status?: string): string {
  const labels: Record<string, string> = {
    open: 'Open',
    waiting_admin_confirmation: 'Pending approval',
    confirmed: 'Confirmed',
    completed: 'Completed',
    rejected: 'Rejected',
  };
  return labels[normMatchStatus(status)] || status || 'Unknown';
}

export function formatMatchType(type?: string): string {
  if (!type) return '—';
  const t = type.toLowerCase();
  return t.charAt(0).toUpperCase() + t.slice(1);
}

export function registeredParticipants(match: Match): MatchParticipant[] {
  return getMatchParticipants(match).filter((p) => p.user_id != null);
}
